export const LR_TOKEN_ANMELDUNG_QUERY_KEY = 'token';
export const LR_TOKEN_COOKIE_KEY = 'lr-user--token';

export const ANMELDUNG_LOGIN_URL_BASE = 'https://anmeldung.tt.com/login?returnUrl=';
export const ANMELDUNG_REGISTER_URL_BASE = 'https://anmeldung.tt.com/register?returnUrl=';
export const ANMELDUNG_PROFILE_URL_BASE = 'https://anmeldung.tt.com/profile';
